import React, { Suspense  } from "react";
import Footer from "./framework/Footer";
import Layout from "./components/Layout";
import navigation from "./components/Navigation";
import webRootContext from "./components/webrootcontext/WebRootContext";


export default function App(props) {

  return (
    <div className="BCHApp">
    		<Suspense  fallback={<h1>Loading profile...</h1>} >
				<Layout version="1.0.new" versionLink="https://www.childrenshospital.org/" navMap={navigation}  webRootContext={webRootContext}  />
			</Suspense>
			<Footer />
    </div>
  );
}
